/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable arrow-body-style */
/* eslint-disable no-lonely-if */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ComparePlan } from '@plans-templates/compare-plan';
import styled from 'styled-components';
import { parseMobileNumber } from '../../../common/plansUtils';

const Description = styled.div``;

const ProdDesc = styled.div`
  font-size: 12px;
  margin-bottom: 12px;
  font-family: Verizon-NHG-eTX, Helvetica, Arial, Sans-serif;
  a {
    color: white;
  }
  a:focus {
    border: 1px dotted white;
  }
`;

const ComparePlanComponent = ({
  toggleOffComplarePlanModel,
  showComparePlanModel,
  comparePlanDetails,
  newPlanId,
  currentPlanId,
  currentPlanObject,
  newPlanObject,
  onPlanSelect,
  priceGuarteeDetails,
  hideCloseButton = false,
}) => {
  const subTitleData = {
    subtitle: {
      children: (
        <>
          {comparePlanDetails?.planDetails?.firstName}
          <br />
          {parseMobileNumber(comparePlanDetails?.planDetails?.mtn)}
        </>
      ),
    },
  };

  const renderingLogic = () => {
    const compareFeatureData = [];
    const wholeFeatureData = [];

    const planDetailsList = comparePlanDetails?.planDetails?.planReferenceDataList;
    const productDetailsList = comparePlanDetails?.planDetails?.planProductReferenceDataList;
    const productGroupsList = comparePlanDetails?.planDetails?.planProductGroupReferenceDataList;

    const masterFeatureOrderList = [
      '5G Premium',
      '5GUWB',
      '5GNW',
      '5GN4GLTE',
      '4GLTE',
      '4GLTE 5Mbps',
      'Talk & Text',
      'Talk & Text 20',
      '5GHotspot',
      'Hotspot',
      '5GStreaming',
      '4GLTE Premium',
      'Streaming',
      'Internet Discount',
      'Disney',
      'Perks',
      'Apple Arcade',
      'Music',
      'Discovery',
      'APPLE_ARCADE',
      'GOOGLE_PASS',
      'Rewards',
      'Discount',
      'Travel Pass',
      'Travel Passes',
      'Verizon Cloud',
      'Smart Family',
      'Mexico & Canada',
      'International Text',
      'Data',
      'Carryover',
      'Safety Mode',
      'Data Boost',
      'Speed',
      'Video',
      'Router',
      'Whole-Home Wi-Fi',
      'Setup',
      'Price Guarantee',
      'Cloud',
      'Promo',
      'Data cap',
      'Contract',
      'Stream',
    ];
    const titleMapper = {
      Video: 'Streaming Quality',
      Cloud: 'Cloud Storage',
      Router: 'Wireless Router',
    };

    // const getActualPlanCost = (planString) => (planString ? planString.replace(/[\$\/mo]/g, '') : planString);
    const highlightProduct = (product) => ({ ...product, icon: { name: 'star' }, prominent: true });

    const NA = '-';
    // const costPrefix = '$';
    // const costSuffix = '/mo';

    const currentPlanData = currentPlanId && planDetailsList && planDetailsList.filter((plan) => String(plan.planId) === String(currentPlanId));
    const newPlanData = currentPlanId && planDetailsList && planDetailsList.filter((plan) => String(plan.planId) === String(newPlanId));
    const currentPlanFeatures = currentPlanData && currentPlanData?.[0]?.planProducts;
    const newPlanFeatures = newPlanData && newPlanData?.[0] && newPlanData?.[0]?.planProducts;
    const currentPlanGroups =
      currentPlanData &&
      currentPlanData?.[0] &&
      currentPlanData?.[0].comparePlanProductGroups &&
      currentPlanData?.[0].comparePlanProductGroups.length > 0
        ? currentPlanData?.[0].comparePlanProductGroups
        : currentPlanData?.[0] && currentPlanData?.[0].planProductGroups;

    const newPlanGroups =
      newPlanData && newPlanData?.[0] && newPlanData?.[0].comparePlanProductGroups && newPlanData?.[0].comparePlanProductGroups.length > 0
        ? newPlanData?.[0].comparePlanProductGroups
        : newPlanData?.[0] && newPlanData?.[0].planProductGroups;

    // current plan group details
    const currentPlanGrouping = [];
    currentPlanGroups &&
      currentPlanGroups.map((groupId) => {
        productGroupsList &&
          productGroupsList.map((group) => {
            if (groupId === group.groupId) currentPlanGrouping.push(group);
          });
      });

    // new plan group details
    const newPlanGrouping = [];
    newPlanGroups &&
      newPlanGroups.map((groupId) => {
        productGroupsList &&
          productGroupsList.map((group) => {
            if (groupId === group.groupId) newPlanGrouping.push(group);
          });
      });

    // Get unique group names for looping
    const uniqueGroupName = [];
    currentPlanGrouping.forEach((getGroup) => {
      return uniqueGroupName.push(getGroup.groupName);
    });
    newPlanGrouping.forEach((getGroup) => {
      let groupFound = false;
      if (uniqueGroupName.find((groupName) => getGroup.groupName === groupName)) {
        groupFound = true;
      }
      if (!groupFound) {
        return uniqueGroupName.push(getGroup.groupName);
      }
    });

    const groupNameSortingArr = ['Network', 'Home Internet Savings', 'Entertainment', 'Connectivity', 'International Features'];
    uniqueGroupName && uniqueGroupName.sort((a, b) => groupNameSortingArr.indexOf(a) - groupNameSortingArr.indexOf(b));
    const checkPriceGuarantee = (feat) => feat === 'Price Guarantee';
    const priceGuarenteeObj = (years) => ({ title: { children: `${years}  years` } });

    masterFeatureOrderList.forEach((featureId) => {
      const checkCurrentGrouping = currentPlanGrouping && currentPlanGrouping.map((prd) => prd.productIds.map((prdId) => prdId));
      const getCurrentGroupsProductIds = checkCurrentGrouping && checkCurrentGrouping.length > 0 ? checkCurrentGrouping.flat() : currentPlanFeatures;

      const checkNewGrouping = newPlanGrouping && newPlanGrouping.map((prd) => prd.productIds.map((prdId) => prdId));
      const getNewGroupsProductIds = newPlanFeatures || (checkNewGrouping && checkNewGrouping.length > 0 && checkNewGrouping.flat());

      const getCurrentProductItems = [];
      getCurrentGroupsProductIds &&
        getCurrentGroupsProductIds.forEach((prdId) => {
          const product = productDetailsList.find((productDet) => productDet.productId === prdId);
          if (product) {
            getCurrentProductItems.push(product);
          }
        });

      const getNewProductItems = [];
      getNewGroupsProductIds &&
        getNewGroupsProductIds.forEach((prdId) => {
          const product = productDetailsList.find((productDet) => productDet.productId === prdId);
          if (product) {
            getNewProductItems.push(product);
          }
        });

      const currentProduct = getCurrentProductItems.filter((prod) => prod.groupId === featureId);
      const newProduct = getNewProductItems.filter((prod) => prod.groupId === featureId);
      if ((currentProduct && currentProduct?.[0]) || (newProduct && newProduct?.[0])) {
        const isPriceGuarantee = checkPriceGuarantee(featureId);
        let titleValue = newProduct[0]?.groupName || currentProduct[0]?.groupName;
        if (titleValue !== 'Network') {
          if (titleMapper[titleValue]) titleValue = titleMapper[titleValue];
          const titleData = {
            type: 'title',
            cells: [
              {
                children: titleValue,
                colSpan: 2,
              },
            ],
          };
          compareFeatureData.push(titleData);
          let currentProductNameVal = currentProduct?.[0]?.compareProductName
            ? currentProduct?.[0]?.compareProductName
            : currentProduct?.[0]?.productName
              ? currentProduct?.[0]?.productName
              : NA;
          let newProductNameVal = newProduct?.[0]?.compareProductName
            ? newProduct?.[0]?.compareProductName
            : newProduct?.[0]?.productName
              ? newProduct?.[0]?.productName
              : NA;
          //  to show included for whole home wifi for 2 product at single in midnight
          if (titleValue === 'Whole-Home Wi-Fi') {
            const routerData = wholeFeatureData.filter((item) => item.title === 'Router Body');
            if (
              routerData?.[0]?.currentProdDetail === 'Router and Whole-Home Wi-Fi included' &&
              currentProductNameVal === '-' &&
              newProductNameVal === 'Included'
            ) {
              currentProductNameVal = 'Included';
            }
            if (
              routerData?.[0]?.newProdDetail === 'Router and Whole-Home Wi-Fi included' &&
              newProductNameVal === '-' &&
              currentProductNameVal === 'Included'
            ) {
              newProductNameVal = 'Included';
            }
          }

          wholeFeatureData.push({
            title: titleValue,
            newProdDetail: newProductNameVal,
            currentProdDetail: currentProductNameVal,
          });
          let newProductObj = { title: { children: newProductNameVal } };
          let currentProductObj = { title: { children: currentProductNameVal } };
          let curCompareVal = currentProduct?.[0]?.compareProductWeightedValue;
          let newCompareVal = newProduct?.[0]?.compareProductWeightedValue;

          if (isPriceGuarantee) {
            newCompareVal = priceGuarteeDetails?.newPlanDetails;
            curCompareVal = priceGuarteeDetails?.currentPlanDetails;
            newProductObj = newCompareVal ? priceGuarenteeObj(newCompareVal) : { title: { children: NA } };
            currentProductObj = curCompareVal ? priceGuarenteeObj(curCompareVal) : { title: { children: NA } };
          }
          if (curCompareVal || newCompareVal) {
            if (curCompareVal && !newCompareVal) currentProductObj = highlightProduct(currentProductObj);
            if (!curCompareVal && newCompareVal) newProductObj = highlightProduct(newProductObj);
            if (curCompareVal && newCompareVal && curCompareVal !== newCompareVal) {
              if (parseInt(curCompareVal) > parseInt(newCompareVal)) currentProductObj = highlightProduct(currentProductObj);
              else newProductObj = highlightProduct(newProductObj);
            }
          }

          if (titleValue === 'Speed') {
            let newMarketDesc = newProduct?.[0]?.marketingDesc;
            newMarketDesc = (typeof newMarketDesc === 'string' && newMarketDesc) || NA;
            newProductObj.text = { children: newMarketDesc };
            let curMarketingDesc = currentProduct?.[0]?.marketingDesc;
            curMarketingDesc = (typeof curMarketingDesc === 'string' && curMarketingDesc) || NA;
            currentProductObj.text = { children: curMarketingDesc };
          }

          const featureData = {
            cells: [currentProductObj, newProductObj],
            content: [
              {
                children: (
                  <Description>
                    {currentProduct[0]?.groupDescription && currentProductObj.title.children !== NA ? (
                      <ProdDesc>
                        <span dangerouslySetInnerHTML={{ __html: currentProduct[0].groupDescription }} />{' '}
                      </ProdDesc>
                    ) : (
                      ''
                    )}
                  </Description>
                ),
              },
              {
                children: (
                  <Description>
                    {newProduct[0]?.groupDescription && newProductObj.title.children !== NA ? (
                      <ProdDesc>
                        <span dangerouslySetInnerHTML={{ __html: newProduct[0].groupDescription }} />{' '}
                      </ProdDesc>
                    ) : (
                      ''
                    )}
                  </Description>
                ),
              },
            ],
            'data-track': titleValue,
          };
          compareFeatureData.push(featureData);
        }
      }
    });
    return compareFeatureData;
  };

  const argument = {
    title: {
      children: 'Compare to your current plan',
    },
    subtitle: subTitleData?.subtitle,
    ariaLabel: 'Compare plan modal',
    opened: showComparePlanModel,
    onOpenedChange: (value) => toggleOffComplarePlanModel(value),
    disableOutsideClick: true,
    buttonData: {
      primary: {
        children: 'Close',
        'data-track': `{"type" : "link", "name" : "close","data" : {"page" : {"detail" : "compare plan modal"}}}`,
        onClick: (value) => toggleOffComplarePlanModel(value),
      },
    },
    taccordion: {
      numberOfColumns: 2,
      head: [
        {
          eyebrow: {
            children: 'Current',
          },
          title: {
            children: currentPlanObject?.planDisplayName,
          },
          subtitle: {
            price: currentPlanObject?.finalPrice !== null &&
              currentPlanObject?.finalPrice !== undefined && {
                price: currentPlanObject?.finalPrice,
                term: 'month',
              },
            children: currentPlanObject?.finalPrice !== null &&
              currentPlanObject?.finalPrice !== undefined && {
                children: 'for this line',
                bold: false,
              },
          },
        },
        {
          badge: {
            children: 'New',
          },
          title: {
            children: newPlanObject?.planDisplayName,
          },
          headerButton: hideCloseButton === false && {
            children: 'Select',
            'data-track': `{"type" : "link", "name" : "select ${newPlanObject?.planDisplayName}","data" : {"page" : {"detail" : "compare plan modal"}}}`,
            onClick: onPlanSelect,
          },
          subtitle: {
            price: newPlanObject?.finalPrice !== null &&
              newPlanObject?.finalPrice !== undefined && {
                price: newPlanObject?.finalPrice,
                term: 'month',
              },
            children: newPlanObject?.finalPrice !== null &&
              newPlanObject?.finalPrice !== undefined && {
                children: 'for this line',
                bold: false,
              },
          },
        },
      ],
      body: renderingLogic() || [],
    },
  };
  return comparePlanDetails?.errorInfo?.status === false && <ComparePlan {...argument} />;
};

export default memo(ComparePlanComponent);

ComparePlanComponent.propTypes = {
  showComparePlanModel: PropTypes.any,
  toggleComplarePlanModel: PropTypes.func,
  comparePlanDetails: PropTypes.any,
  newPlanId: PropTypes.any,
  currentPlanId: PropTypes.any,
  currentPlanObject: PropTypes.any,
  newPlanObject: PropTypes.any,
};
